import { render } from "./AddInventoryRuleModal.vue?vue&type=template&id=07de5c5a&ts=true"
import script from "./AddInventoryRuleModal.vue?vue&type=script&lang=ts"
export * from "./AddInventoryRuleModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__